import { Route } from 'types/route.type';
import { routes as calibrations } from './features/calibrations/routes';
import { routes as scenarios } from './features/scenarios/routes';
import { routes as bluViuNutritionR2 } from './features/scenarios-v2/routes';

export const routes: Route[] = [...bluViuNutritionR2, ...scenarios, ...calibrations];
